import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  loader: {
    color: "white !important",
  },
}));

const SaveButton = props => {
  const { disabled, loading, onClick } = props;
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      color="primary"
      disabled={disabled}
      onClick={onClick}
    >
      {loading ? (
        <CircularProgress size="30px" classes={{ root: classes.loader }} />
      ) : (
        "Save"
      )}
    </Button>
  );
};

export default SaveButton;
